<template>
  <div class="card row cardBemVindo">
    <div class="col-12">
      <h4>{{ $t('Status por Mecânico') }}</h4>
      <!-- <canvas id="myChartProdutividade"></canvas> -->
      <div class="details">
        <table class="table table-light">
          <!-- <thead>
            <tr>
              <th scope="col">Mecânico</th>
              <th scope="col">Status</th>
            </tr>
          </thead> -->
          <tbody>
            <tr v-for="(item, index) in statusMecanico" :key="index">
              <td scope="col-2">⭐ {{ parseFloat(item.nota || 0).toFixed(2) }}</td>
              <td scope="col">{{ item.nome_colaborador.substring(0, 15) }}</td>
              <td scope="col" :class="styleCard(item.status)">{{ item.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart } from 'chart.js';

export default {
  data() {
    return {
      statusMecanico: [], // Armazena os dados de produtividade
    };
  },
  computed: {

  },
  mounted() {
    this.$store.dispatch('dashboard/getProdutividadeMecanico').then(response => {
      this.statusMecanico = response.data.status_mecanico; // Armazena os dados

      // // Limitar os nomes dos colaboradores a 10 caracteres
      // const labels = this.produtividadeData.map(item => {
      //   const nome = item.ds_colaborador;
      //   return nome.length > 10 ? nome.substring(0, 10) + '...' : nome;
      // });

      // // Mapear o total de produtividade (dados)
      // const data = this.produtividadeData.map(item => item.total);
      // console.log(labels)
      // console.log(data)

      // // Criar o gráfico com os dados do backend
      // this.renderChart(labels, data);
    });
  },
  
  methods: {
    styleCard(value){
      if(value == 'Trabalhando' || value == this.$t('Trabalhando')){
        return 'cardVerde '
      } else {
        return 'cardVermelho'

      }
    },
    renderChart(labels, data) {
      const ctx = document.getElementById('myChartProdutividade').getContext('2d');

      if (ctx) {
        new Chart(ctx, {
          type: 'pie',
          data: {
            labels: labels, // Labels truncados
            datasets: [
              {
                label: this.$t('Produtividade'),
                data: data, // Dados de produtividade
                backgroundColor: [
                  '#ff6384',
                  '#ffcd56',
                  '#36a2eb',
                  '#ff9f40',
                  '#4bc0c0',
                  '#9966ff',
                  '#ff9f40',
                  '#ffcd56',
                  '#c9cbcf',
                ],
                borderColor: [
                  '#fff',
                  '#fff',
                  '#fff',
                  '#fff',
                  '#fff',
                  '#fff',
                  '#fff',
                  '#fff',
                  '#fff',
                ],
                borderWidth: 1,
              },
            ],
          },
          options: {
            maintainAspectRatio: false,
            responsive: true,
            plugins: {
              legend: {
                position: 'bottom',
              },
              title: {
                display: true,
                text: 'Produtividade por Mecânico',
              },
            },
            layout: {
              padding: 20,
            },
            elements: {
              arc: {
                borderWidth: 2,
                hoverOffset: 10,
              },
            },
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.cardBemVindo {
  flex-direction: row;
  align-items: flex-end;
}

#myChartProdutividade {
  height: 400px; /* Altura fixa para o gráfico */
  max-height: 400px;
  width: 100%; /* Largura ajustada para 100% */
}

.details {
  margin-top: 20px; /* Espaçamento entre o gráfico e os detalhes */
}

table {
  width: 100%; /* Ocupar toda a largura disponível */
  border-collapse: collapse; /* Colapsa as bordas da tabela */
}

th, td {
  border: 1px solid #ddd; /* Borda padrão para células */
  padding: 8px; /* Espaçamento interno nas células */
  text-align: left; /* Alinhamento à esquerda do texto */
  font-size: 18px
}

th {
  background-color: #f2f2f2; /* Cor de fundo para cabeçalhos */
}
.cardVermelho {
  background-color: #fff;
    color: #c90f0f;
    border: 2px solid #c90f0f;
    border-radius: 50px !important;
    text-align: center;
    font-weight: 400;
}

.cardVerde {
  background-color: #fff;
    color: #0ead09;
    border: 2px solid #0ead09;
    border-radius: 50px !important;
    text-align: center;
    font-weight: 400;
}


</style>
